import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../src/navbar';
import { productsService } from '../../services/api/products.service';

function CategoryAdd() {
  const [name, setName] = useState('');
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      if (!name.trim()) {
        setError('Name is required');
        setLoading(false);
        return;
      }
      const formData = new FormData();
      formData.append('name', name);
      formData.append('description', description);
      if (image instanceof File) {
        formData.append('image', image);
      }
      await productsService.createCategory(formData);
      navigate('/categories');
    } catch (err) {
      setError((err && (err.message || err.error)) || String(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex">
        <Navbar />
      </div>
      <div className="max-w-3xl mx-auto p-4 mt-20">
        <h1 className="text-2xl font-bold mb-4">Add Category</h1>
        {error && <div className="text-red-600 mb-4">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium">Name</label>
            <input value={name} onChange={(e) => setName(e.target.value)} className="w-full border rounded px-3 py-2" required />
          </div>
          <div>
            <label className="block text-sm font-medium">Image</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="w-full border rounded px-3 py-2"
            />
            {imagePreview && (
              <div className="mt-4">
                <img src={imagePreview} alt="Preview" className="max-w-xs h-auto rounded" />
              </div>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium">Description</label>
            <textarea value={description} onChange={(e) => setDescription(e.target.value)} className="w-full border rounded px-3 py-2" rows={4} />
          </div>
          <div>
            <button type="submit" disabled={loading} className="bg-blue-600 text-white px-4 py-2 rounded">
              {loading ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default CategoryAdd;
